import { render, staticRenderFns } from "./SalePageCard.vue?vue&type=template&id=2fa803c0&scoped=true&"
import script from "./SalePageCard.vue?vue&type=script&lang=js&"
export * from "./SalePageCard.vue?vue&type=script&lang=js&"
import style0 from "./SalePageCard.vue?vue&type=style&index=0&id=2fa803c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa803c0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VChip,VIcon,VImg,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa803c0')) {
      api.createRecord('2fa803c0', component.options)
    } else {
      api.reload('2fa803c0', component.options)
    }
    module.hot.accept("./SalePageCard.vue?vue&type=template&id=2fa803c0&scoped=true&", function () {
      api.rerender('2fa803c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SalePage/components/SalePageCard.vue"
export default component.exports